// extracted by mini-css-extract-plugin
export default {"legendFormStyle":"index_legendFormStyle__06WG4"};